function createRecurrentRequest(form) {
  const formData = new FormData();
  formData.append('file', form.file);
  formData.append('template_id', form.template_id);
  formData.append('name', form.name);
  formData.append('periodicity', form.periodicity);

  return formData;
}

const actions = {
  async fetchRecurrent({ commit, rootState: { $http } }, id) {
    const { data } = await $http.get(`/recurrent/${id}`);

    commit('setRecurrent', data);
  },
  async fetchRecurrents({ commit, rootState: { $http } }, { page }) {
    const { data } = await $http.get('/recurrent', { params: { page } });

    commit('setRecurrents', data);
  },
  async fetchHistorical({ commit, rootState: { $http } }, { id, page }) {
    const { data } = await $http.get(`/recurrent/${id}/historical`, { params: { page } });

    commit('setHistorical', data);
  },

  async create({ rootState: { $http } }, form) {
    const formData = createRecurrentRequest(form);

    await $http.post('/recurrent', formData);
  },

  async update({ rootState: { $http } }, { id, form }) {
    const formData = createRecurrentRequest(form);

    await $http.post(`/recurrent/${id}`, formData);
  },

  async calculateTotal({ commit, rootState: { $http } }, form) {
    const formData = createRecurrentRequest(form);

    const { data } = await $http.post('/recurrent/total', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    commit('setTotal', data.total);
  },

  async delete({ rootState: { $http } }, id) {
    await $http.delete(`/recurrent/${id}`);
  },

  async toggle({ rootState: { $http } }, id) {
    await $http.patch(`/recurrent/${id}/toggle`);
  },
};

export default actions;
